import {
  idColumn,
  nameColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn } from "../../../../../utils/commonFunctions";

const useColumnDefs = [
    idColumn,
    nameColumn,
    {
      ...generateColumn("Has Leadership?", "has_leadership"),
    },
    {
      ...generateColumn("High School Diploma or GED", "high_school_diploma_or_ged"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("", "associate_degree"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("", "bachelors_degree"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("", "masters_degree"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("", "pre_apprenticeship"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("", "apprenticeship"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("", "not_available"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("", "doctoral_degree"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    statusColumn,
    actionColumn,
  ];
export default useColumnDefs;
